<template>
  <div id="app">
    <div v-if="auth && dataLoaded">

      <app-header v-if="auth && dataLoaded"></app-header>

      <div :class="{'loading-screen': true, 'show-loading': apiBusy}">
        <div class="loading">
          Working...
        </div>
      </div>

      <section class="section" v-if="!showPrint">
        <transition mode="out-in" name="page-fade-up">
          <router-view></router-view>
        </transition>
      </section>

      <print-dialog v-if="showPrint" :type="printType" :contents="printContents"></print-dialog>
    </div>

    <div v-else class="preloading">
      <loader></loader>
    </div>
  </div>
</template>

<style lang="scss" rel="stylesheet/scss">
  @import "./sass/include";
</style>

<script>
import {
  FETCH_ADMIN,
  FETCH_DATA,
  REFRESH_ORDERS,
  MARK_PRINTED_ORDERS,
  MARK_PRINTED_CATALOG_REQUESTS, FETCH_PRIORITY_DATA
}                   from "./store/mutation-types"
import {mapGetters} from "vuex";

export default {
  name: 'app',
  data() {
    return {
      dataLoaded: false,
      showPrint: false,
      printType: 'orders',
      printContents: [],
      refreshInterval: 0,
      refreshTime: 1000 * 120,
    }
  },
  computed: mapGetters(['auth', 'admin', 'isSuperUser', 'apiBusy', 'newOrders']),
  mounted() {
    clearInterval(this.refreshInterval);
    this.$store.dispatch(FETCH_ADMIN)
        .then(data => {
          this.$store.dispatch(FETCH_PRIORITY_DATA).then(data => {
            this.dataLoaded = true
            this.$store.dispatch(FETCH_DATA)
            this.updateTitle();
            this.refreshInterval = setInterval(() => {
              this.$store.dispatch(REFRESH_ORDERS, false)
            }, this.refreshTime)
          })
        })

    this.$bus.$on('startPrint', this.startPrint)
    this.$bus.$on('stopPrint', this.stopPrint)
    window.addEventListener('resize', this.handleResize, false)
  },
  beforeDestroy() {
    this.$bus.$off('startPrint', this.startPrint)
    this.$bus.$off('stopPrint', this.stopPrint)
    window.removeEventListener('resize', this.handleResize, false)
  },
  methods: {
    handleResize(e) {
      let newSize = [e.target.innerWidth, e.target.innerHeight]
      this.$bus.$emit('resize', newSize)
    },
    startPrint(payload) {
      this.printType     = payload.type
      this.printContents = payload.contents
      this.showPrint     = true
    },
    stopPrint(payload) {
      this.showPrint = false
      if (payload.type === 'order' && payload.markAsPrinted === true) {
        this.$store.dispatch(MARK_PRINTED_ORDERS, payload.contents.map(order => order.id))
      }
      if (payload.type === 'request' && payload.markAsPrinted === true) {
        this.$store.dispatch(MARK_PRINTED_CATALOG_REQUESTS, payload.contents.map(request => request.id))
      }
    },
    updateTitle() {
      document.title = 'Fruit Admin' + (this.newOrders.length > 0 ? ' (' + this.newOrders.length + ' new)' : '');
    }
  },
  watch: {
    newOrders() {
      this.updateTitle();
    }
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?5efda52a